const list = ['TEFAFArtObjects'];
const categoryValues = ['TEFAFArtObjectCategoryValues'];
const comments = ['TEFAFArtObjectComments'];

export { list, categoryValues, comments };
